import { Currency } from "@generated"

export enum SubscriptionType {
  FREE = "Free",
  BASIC = "Basic",
  BUSINESS = "Business",
}

export const pricesByCurrencies = {
  [Currency.Eur]: {
    symbol: "€",
    prices: {
      Basic: {
        main: 8.5,
        topUp: 4.2,
      },
      Business: {
        main: 80,
        topUp: 28.0,
      },
    },
  },
  [Currency.Usd]: {
    symbol: "$",
    prices: {
      Basic: {
        main: 10,
        topUp: 5,
      },
      Business: {
        main: 90,
        topUp: 33,
      },
    },
  },
}
